import { Button, Radio } from 'antd';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { RedirectIcon } from 'app/components/pages/Hotels/RedirectIcon';
import { ConfigContext } from 'app/context/ConfigContext/ConfigContext';
import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { useCountries } from 'app/hooks/data/useCountries';

import { PackType, packagesStore } from '../../../PackageStore';
import { useInitialPackType } from '../../../_hooks/useInitialPackType';

type PackagesActionProps = {
  hasPreviewButton: boolean;
};

export const PackagesAction = ({ hasPreviewButton }: PackagesActionProps) => {
  useInitialPackType();

  const { hotelInfo } = useContext(HotelContext);
  const { packsList } = useContext(ModernHotelContext);
  const configContext = useContext(ConfigContext);

  const { data: countries } = useCountries();
  const country = countries?.find((c) => c.id === hotelInfo?.countryId);

  const packType = useStore(packagesStore, (state) => state.packType);
  const setPackType = useStore(packagesStore, (state) => state.setPackType);
  const selectedPackId = useStore(
    packagesStore,
    (state) => state.selectedPackId
  );

  const isDaytime = packType === PackType.DAYTIME;

  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const options = Object.values(PackType).map((packType) => ({
    label: packType === PackType.NIGHT_STAY ? 'Night stay' : 'Daytime',
    value: packType,
  }));

  const handlePreviewHotelPage = () => {
    const urlFirstPart = `${configContext?.appUrl}/${country?.locale}/hotels`;

    if (isDaytime && selectedPackId) {
      // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
      const pack = packsList.find((pack) => pack.id === selectedPackId);

      const daytimePacksUrl = `${urlFirstPart}/${pack?.slug}`;

      window.open(daytimePacksUrl, '_blank');

      return;
    }

    const hotelPageUrl = `${urlFirstPart}/${hotelInfo?.slug}`;

    window.open(hotelPageUrl, '_blank');
  };

  return (
    <>
      <Radio.Group
        options={options.map((option) => ({
          label: option.label,
          value: option.value,
        }))}
        onChange={(e) => setPackType(e.target.value)}
        value={packType}
        optionType="button"
      />
      {hasPreviewButton && (
        <Button onClick={handlePreviewHotelPage}>
          {isDaytime ? 'Preview package' : 'Preview hotel page'}
          <RedirectIcon />
        </Button>
      )}
    </>
  );
};
